import React, { Component } from 'react';
// import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
// import language from '../../../assets/languages/language';
// import { EXAM_MAPPING, ROLES } from '../../../common/constant';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
// import { renderHTMLContent } from '../../../common/function';
// import { retrieveSpecialPrice } from '../../../common/function';
import Loader from '../../../common/loader';
// import CheckboxComponent from './Checkbox';
// import BuyPackages from './BuyPackages';
import userStore from '../../../store/userStore';
import { showFailure, showInformation } from '../../../common/toast';
import { formatMoney, formatPrettyDate } from '../../../utils/CommonUtils';
import { SHOW_CFA_UNLIMITED_PLUS, CFA_UNLIMITED_PLUS_PACKAGE_ID } from '../../../common/constant';
import { trackAddToCart } from '../../../common/analytics';
import '../../../assets/css/subscribe.css';
import {
  getSubscriptionBadge,
  getSubscriptionDateLabel,
} from '../../../common/subscriptionBadge';

/* eslint-disable */

// Three rows overflowed the header; two is the agreed ceiling (2026-09-01).
const MAX_HEADER_ENTITLEMENTS = 2;

class SelectPackage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      errorMessage: "",
      exam: null,
      owned: null,
      packages: [],
      selectedAddonsByPlanId: {},
      headerPurchase: null,
      headerEntitlements: [],
      // Design 2b — page-level billing switch. 'year' | 'monthly'.
      billingTerm: "year",
    };

    this.loadCoursePackages = this.loadCoursePackages.bind(this);
    this.goBackToCourses = this.goBackToCourses.bind(this);
    this.onToggleAddon = this.onToggleAddon.bind(this);
    this.getSelectedAddonsTotal = this.getSelectedAddonsTotal.bind(this);
    this.handleAddToCart = this.handleAddToCart.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.renderAddons = this.renderAddons.bind(this);
    this.renderPlanCard = this.renderPlanCard.bind(this);
    this.setBillingTerm = this.setBillingTerm.bind(this);
    this.getIntervalLabel = this.getIntervalLabel.bind(this);
  }

  componentDidMount() {
    this.loadCoursePackages();
  }

  async loadCoursePackages() {
    this.setState({ isLoading: true, errorMessage: "" });
    const { exam_id: examId, exam_name: examName } = (this.props.params || {});

    FD.callAPI(App_data.backend_api + "/checkout_v1/getExamPackagesByUserId", {
      examId,
      examName
    })
      .then((resp) => {
        if (resp && resp.success) {
          // #216 — hide CFA Unlimited+ (pkg 78) from the purchase flow while the
          // launch is deferred. Filter is gated by a feature flag so backend /
          // ownership checks for existing test purchases stay intact.
          const allPackages = Array.isArray(resp.packages) ? resp.packages : [];
          const visiblePackages = SHOW_CFA_UNLIMITED_PLUS
            ? allPackages
            : allPackages.filter((p) => {
              if (!p) return false;
              if (String(p.package_val).toLowerCase() === 'plus') return false;
              if (Number(p.planId) === CFA_UNLIMITED_PLUS_PACKAGE_ID) return false;
              return true;
            });

          this.setState({
            isLoading: false,
            errorMessage: "",
            exam: resp.exam,
            owned: resp.owned,
            packages: visiblePackages,
            selectedAddonsByPlanId: {},
            headerPurchase: resp.headerPurchase,
            headerEntitlements: resp.headerEntitlements || [],
          });
        } else {
          const msg = (resp && resp.message) ? resp.message : "Failed to load packages";
          this.setState({
            isLoading: false,
            errorMessage: msg,
            exam: null,
            owned: null,
            packages: [],
            selectedAddonsByPlanId: {},
            headerPurchase: null,
          });
          showInformation(msg);
        }
        return resp;
      })
      .catch(() => {
        this.setState({
          isLoading: false,
          errorMessage: "Error loading packages",
          exam: null,
          owned: null,
          packages: [],
          selectedAddonsByPlanId: {},
          headerPurchase: null,
        });
        showFailure("Error loading packages");
      });
  }

  goBackToCourses() {
    this.props.router.push('/subscribe');
  }

  getPlanIdWithAnySelectedAddons(selectedMap) {
    const map = selectedMap || {};
    const planIds = Object.keys(map);

    for (let i = 0; i < planIds.length; i++) {
      const pid = planIds[i];
      const addonsMap = map[pid] || {};
      const addonIds = Object.keys(addonsMap);

      for (let j = 0; j < addonIds.length; j++) {
        const aid = addonIds[j];
        if (addonsMap[aid]) return pid;
      }
    }
    return null;
  }

  onToggleAddon(planId, addonId) {
    this.setState((prevState) => {
      const selectedMap = prevState.selectedAddonsByPlanId || {};

      const activePlanId = this.getPlanIdWithAnySelectedAddons(selectedMap);

      if (activePlanId && String(activePlanId) !== String(planId)) {
        showInformation("You can select add-ons for only one package at a time.");
        return null;
      }

      const prevPlanMap = selectedMap[planId] || {};
      const nextPlanMap = { ...prevPlanMap };
      nextPlanMap[addonId] = !nextPlanMap[addonId];

      const next = { ...selectedMap, [planId]: nextPlanMap };
      return { selectedAddonsByPlanId: next };
    });
  }

  getOwnedAddonsTotal(plan) {
    if (!plan) return 0;
    const addons = plan.addons || [];
    let total = 0;

    for (let i = 0; i < addons.length; i++) {
      const a = addons[i];
      if (!a) continue;
      if (a.owned) total += Number(a.price || 0);
    }
    return total;
  }

  getSelectedAddonsTotal(plan) {
    if (!plan) return 0;

    const selectedMap = this.state.selectedAddonsByPlanId || {};
    const planMap = selectedMap[plan.planId] || {};
    const addons = plan.addons || [];
    let total = 0;

    for (let i = 0; i < addons.length; i++) {
      const a = addons[i];
      if (!a || a.owned || a.inherited) continue;
      if (planMap[a.id]) total += Number(a.price || 0);
    }
    return total;
  }

  // ── Design 2b — page-level billing switch ────────────────────────────
  // A plan is "recurring" when exam_plans.payment_interval is set.
  isRecurringPlan(plan) {
    return !!(plan && plan.payment_interval);
  }

  // Only study tiers can have a monthly twin. unlimited / plus are lifetime
  // one-time purchases and never respond to the switch. Mock packages are
  // excluded even though they share package_val with a study tier (CFA L1
  // pkg 65 is `expensive` + category 'mock') — otherwise the switch would
  // swap the mock card out for the monthly Learn + Practice plan.
  isSwitchablePlan(plan) {
    if (!plan || this.isMockPlan(plan.package_category)) return false;
    return plan.package_val === "simple" || plan.package_val === "expensive";
  }

  // Count year/monthly variants per tier. Twins are matched on package_val,
  // unambiguous for CFA L1 today (one 'simple', one 'expensive') — see spec 11.1.
  getTermVariantCounts(packages) {
    const tiers = {};
    for (let i = 0; i < (packages || []).length; i++) {
      const p = packages[i];
      if (!this.isSwitchablePlan(p)) continue;
      const t = tiers[p.package_val] || { year: 0, monthly: 0 };
      if (this.isRecurringPlan(p)) t.monthly += 1;
      else t.year += 1;
      tiers[p.package_val] = t;
    }
    return tiers;
  }

  // The switch only renders when a tier genuinely offers BOTH terms.
  // Exams with a monthly-only plan (GMAT Focus, pkg 57) must keep rendering
  // it, and would show an empty grid under a naive year-default filter.
  hasBillingChoice(packages) {
    const tiers = this.getTermVariantCounts(packages);
    const keys = Object.keys(tiers);
    for (let i = 0; i < keys.length; i++) {
      if (tiers[keys[i]].year > 0 && tiers[keys[i]].monthly > 0) return true;
    }
    return false;
  }

  filterPackagesByTerm(packages, term) {
    // Monthly view shows monthly packages ONLY — no one-time tiers alongside
    // them (requirement 2026-08-25).
    if (term === "monthly") {
      return (packages || []).filter((p) => this.isRecurringPlan(p));
    }

    // Yearly view: every one-time plan, plus any recurring plan whose tier has
    // no one-time twin. That last case keeps monthly-only exams working —
    // GMAT Focus (pkg 57) has no yearly variant and would otherwise render an
    // empty grid, since 'year' is the default term and it gets no switch.
    const tiers = this.getTermVariantCounts(packages);
    return (packages || []).filter((p) => {
      if (!this.isRecurringPlan(p)) return true;
      if (!this.isSwitchablePlan(p)) return false;
      const t = tiers[p.package_val] || { year: 0, monthly: 0 };
      return t.year === 0;
    });
  }

  setBillingTerm(term) {
    if (term === this.state.billingTerm) return;
    this.setState({ billingTerm: term });
  }

  isMockPlan(packageCategory) {
    return !!(packageCategory === "mock");
  }

  getTierScore(plan) {
    if (!plan) return 0;

    const isPlus = plan.package_val === "plus";
    const isUnlimited = plan.package_val === "unlimited";
    const isExpensive = plan.package_val === "expensive";
    const isSimple = plan.package_val === "simple";

    if (isPlus) return 400;
    if (isUnlimited) return 300;
    if (isExpensive) return 200;
    if (isSimple) return 100;
    return 50;
  }

  getPlanRank(plan) {
    const tier = this.getTierScore(plan);
    const price = Number(plan.price || 0);
    const id = Number(plan.planId || 0);
    return tier * 1000000 + price * 1000 + id;
  }

  // `ignoreRecurring` — a monthly subscription must never make a 12-month
  // package look "Included in Purchased Package". Monthly ranks BELOW yearly
  // regardless of tier: a subscriber has to be able to switch to the yearly
  // plan, and buying it supersedes the subscription (spec §9).
  getMaxOwnedRank(packages, onlyMock, ignoreRecurring) {
    let maxRank = -1;

    for (let i = 0; i < packages.length; i++) {
      const p = packages[i];
      if (!p || !p.isOwned) continue;

      const isMock = this.isMockPlan(p.package_category);
      if (onlyMock && !isMock) continue;
      if (!onlyMock && isMock) continue;
      if (ignoreRecurring && this.isRecurringPlan(p)) continue;

      const r = this.getPlanRank(p);
      if (r > maxRank) maxRank = r;
    }

    return maxRank;
  }

  getPrimaryOwnedPlan(packages) {
    let bestNonMock = null;
    let bestNonMockRank = -1;

    let bestMock = null;
    let bestMockRank = -1;

    for (let i = 0; i < packages.length; i++) {
      const p = packages[i];
      if (!p || !p.isOwned) continue;

      const r = this.getPlanRank(p);
      if (this.isMockPlan(p.package_category)) {
        if (r > bestMockRank) {
          bestMockRank = r;
          bestMock = p;
        }
      } else {
        if (r > bestNonMockRank) {
          bestNonMockRank = r;
          bestNonMock = p;
        }
      }
    }

    return bestNonMock || bestMock || null;
  }

  hasOwnedNonMockUnlimited(packages) {
    for (let i = 0; i < packages.length; i++) {
      const p = packages[i];
      if (!p || !p.isOwned) continue;
      if (this.isMockPlan(p.package_category)) continue;
      if (p.package_val === "unlimited" || p.package_val === "plus") return true;
    }
    return false;
  }

  isIncludedInPurchasedPackage(plan, packages) {
    if (!plan) return false;

    const isMock = this.isMockPlan(plan.package_category);
    const examId = Number(plan.exam_id);

    if (!isMock && this.isSpecialExamWithExplicitRules(examId)) {
      for (let i = 0; i < packages.length; i++) {
        const ownedPlan = packages[i];
        if (!ownedPlan || !ownedPlan.isOwned) continue;

        if (this.isMockPlan(ownedPlan.package_category)) continue;
        if (Number(ownedPlan.exam_id) !== examId) continue;
        // A subscription never blocks a one-time purchase.
        if (!this.isRecurringPlan(plan) && this.isRecurringPlan(ownedPlan)) continue;

        if (this.isExplicitlyIncludedByOwnedPlan(plan, ownedPlan)) {
          return true;
        }
      }

      // Reverse: if target is composite (e.g. L+P) and ALL its components are owned
      if (this.isCompositeIncludedByComponents(plan, packages)) {
        return true;
      }

      return false;
    }

    const rank = this.getPlanRank(plan);

    if (isMock && this.hasOwnedNonMockUnlimited(packages)) return true;

    // When judging a ONE-TIME plan, owned monthly plans do not count — see
    // getMaxOwnedRank. When judging a monthly plan they do, so a lower monthly
    // tier is still correctly shown as included in a higher one.
    const ignoreRecurring = !this.isRecurringPlan(plan);
    const maxOwnedRankSameGroup = this.getMaxOwnedRank(packages, isMock, ignoreRecurring);
    if (maxOwnedRankSameGroup <= 0) return false;

    return rank < maxOwnedRankSameGroup;
  }

  shouldShowUpgrade(plan) {
    if (!plan || plan.isOwned) return false;
    if (this.isMockPlan(plan.package_category)) return false;
    // No upgrade path into a monthly plan (requirement 2026-08-25). Design 2h
    // states the same rule in the cart: upgrades are 12-month billing only.
    if (this.isRecurringPlan(plan)) return false;
    return !!plan.upgradeAvailable;
  }

  isBestValue(plan) {
    if (!plan || plan.isOwned || this.isMockPlan(plan.package_category)) return false;
    return plan.package_val === "unlimited" || plan.package_val === "plus";
  }

  SPECIAL_INCLUDED_PLANS = {
    13: { // GMAT Prep
      45: [43, 44], // Learn + Practice includes Learn + Practice
    },
    14: { // Executive Assessment
      53: [51, 52], // Learn + Practice includes Learn + Practice
    },
  };

  isSpecialExamWithExplicitRules(examId) {
    return !!this.SPECIAL_INCLUDED_PLANS[Number(examId)];
  }

  getExplicitlyIncludedPlanIds(ownedPlan) {
    if (!ownedPlan) return [];

    const examId = Number(ownedPlan.exam_id);
    const ownedPlanId = Number(ownedPlan.planId);

    const examRules = this.SPECIAL_INCLUDED_PLANS[examId];
    if (!examRules) return [];

    return examRules[ownedPlanId] || [];
  }

  isExplicitlyIncludedByOwnedPlan(targetPlan, ownedPlan) {
    if (!targetPlan || !ownedPlan) return false;

    const targetPlanId = Number(targetPlan.planId);
    const includedPlanIds = this.getExplicitlyIncludedPlanIds(ownedPlan);

    return includedPlanIds.includes(targetPlanId);
  }

  // Reverse check: if target is a composite plan (e.g. L+P expensive)
  // and ALL its component plans (e.g. Learn simple + Practice simple) are owned
  isCompositeIncludedByComponents(targetPlan, packages) {
    if (!targetPlan) return false;
    const examId = Number(targetPlan.exam_id);
    const targetPlanId = Number(targetPlan.planId);

    const examRules = this.SPECIAL_INCLUDED_PLANS[examId];
    if (!examRules) return false;

    const componentIds = examRules[targetPlanId];
    if (!componentIds || componentIds.length === 0) return false;

    for (let i = 0; i < componentIds.length; i++) {
      const cid = componentIds[i];
      let found = false;
      for (let j = 0; j < packages.length; j++) {
        if (packages[j] && packages[j].isOwned && Number(packages[j].planId) === cid) {
          found = true;
          break;
        }
      }
      if (!found) return false;
    }
    return true;
  }

  fireAddToCartTracking(plan, displayPrice) {
    try {
      const { exam } = this.state;
      const profile = (userStore && userStore.profileInfo) || {};
      const value = Number(displayPrice) || Number(plan && plan.price) || 0;
      trackAddToCart({
        exam: (exam && exam.uiTitle) || '',
        packageType: (plan && plan.package_type) || '',
        value,
        userName: profile.username || '',
        userEmail: profile.email || '',
        source: (userStore && userStore.landingSource) || 'organic',
        affiliateName: (userStore && userStore.landingSourceName) || null,
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('SelectPackage trackAddToCart failed:', e && e.message);
    }
  }

  handleAddToCart(plan, isOwned, proposeUpgrade, displayPrice) {
    if (!plan) return;

    const examId = Number(plan.exam_id);
    const planId = Number(plan.planId);

    const selectedMap = this.state.selectedAddonsByPlanId || {};
    const planMap = selectedMap[planId] || {};
    const addons = plan.addons || [];

    const addonIds = [];

    for (let i = 0; i < addons.length; i++) {
      const a = addons[i];
      if (!a || a.owned) continue;
      // Auto-include inherited addons (price will be 0 on backend)
      if (a.inherited || planMap[a.id]) addonIds.push(a.id);
    }

    let type = isOwned ? "unlessUnlimited" : "main";
    const payload = {
      examId: examId,
      planId: planId,
      addonIds: addonIds,
    };

    if (proposeUpgrade && plan.upgradeAvailable) {
      type = plan.upgradeType || "upgrade_standard";
      payload.upgradeFromPlanId = plan.upgradeFromPlanId;
      payload.displayPrice = displayPrice;
    }

    payload.type = type;

    FD.callAPI(App_data.backend_api + "/checkout_v1/addToUserCart", payload)
      .then((resp) => {
        if (resp && resp.success) {
          // Conversion tracking — fire GTM/GA4/FB AddToCart events for this
          // package selection. Lost when this component replaced the legacy
          // Subscribe/SelectPackage.js. See common/analytics.js.
          this.fireAddToCartTracking(plan, displayPrice);

          this.props.router.push("/cart");
        } else {
          const msg = (resp && resp.message) ? resp.message : "Failed to add to cart";
          showInformation(msg);
        }
      })
      .catch(() => {
        showFailure("Failed to add to cart");
      });
  }

  // One block per active entitlement. A user can hold several at once — a
  // mock package alongside a monthly subscription — and naming only the
  // "primary" one hid the rest (decided 2026-09-01: show every one, no cap).
  renderEntitlement(item, index) {
    const sub = item.subscription || null;
    const badge = getSubscriptionBadge(sub);
    const dateLabel = getSubscriptionDateLabel(sub);
    // The subscription's own expiry is authoritative when present; the
    // derived expirationDate can lag.
    const expiry =
      sub && sub.expiryDate
        ? formatPrettyDate(sub.expiryDate)
        : item.expirationDate
          ? formatPrettyDate(item.expirationDate)
          : null;
    const purchased = item.purchaseDate ? formatPrettyDate(item.purchaseDate) : null;

    return (
      <div className="sp_purchased_container" key={item.planId || index}>
        <div
          className={
            'sp_purchased_header sb_card_meta_row' +
            (sub ? ' sp_badge_tone_' + badge.tone : '')
          }
        >
          <span className="sb_card_meta_icon sp_icon_purchased" />
          <span>{badge.label}</span>
        </div>

        <div className="sp_purchased_title">{item.package_type || 'Purchased'}</div>

        {purchased && (
          <div className="sb_card_meta_row sb_card_meta_row_grey">
            <span className="sb_card_meta_icon sb_card_meta_icon_calendar" />
            <span>{(sub ? 'Subscribed: ' : 'Purchased: ') + purchased}</span>
          </div>
        )}

        {expiry && !item.hasLifetimeAccess && (
          <div className="sb_card_meta_row sb_card_meta_row_grey">
            <span className="sb_card_meta_icon sb_card_meta_icon_clock" />
            <span>{dateLabel + expiry}</span>
          </div>
        )}

        {(item.hasLifetimeAccess || item.hasUnlimitedTutor) && (
          <div className="sb_card_meta_row sb_card_meta_row_green">
            {item.hasLifetimeAccess && (
              <div className="sb_card_meta_row">
                <span className="sb_card_meta_icon sb_card_meta_icon_infinity" />
                <span>Lifetime</span>
              </div>
            )}

            {item.hasUnlimitedTutor && (
              <div className="sb_card_meta_row">
                <span className="sb_card_meta_icon sb_card_meta_icon_chat" />
                <span>Unlimited Tutor</span>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  // What the header should actually list. Two rules, both from real cases:
  //  1. A package already covered by a bigger one is noise — owning "Mock
  //     Unlimited (All 3 Levels)" makes "Mock (Learn + Practice)" redundant,
  //     and the plan card itself says "Included in Purchased Package".
  //     Reuses the card's own coverage rule so the two cannot disagree.
  //  2. Cap at MAX_HEADER_ENTITLEMENTS — three rows was already too much.
  visibleHeaderEntitlements() {
    const { packages, headerEntitlements } = this.state;
    const list = headerEntitlements || [];
    if (list.length < 2) return list;

    const planById = {};
    for (let i = 0; i < (packages || []).length; i++) {
      const p = packages[i];
      if (p) planById[String(p.planId)] = p;
    }

    const kept = [];
    for (let i = 0; i < list.length; i++) {
      const plan = planById[String(list[i].planId)];
      if (plan && this.isIncludedInPurchasedPackage(plan, packages || [])) continue;
      kept.push(list[i]);
    }

    return (kept.length ? kept : list).slice(0, MAX_HEADER_ENTITLEMENTS);
  }

  renderHeader() {
    const { exam, packages, headerPurchase } = this.state;
    const headerEntitlements = this.visibleHeaderEntitlements();

    const primaryOwned = this.getPrimaryOwnedPlan(packages || []);

    const purchasedPretty =
      headerPurchase && headerPurchase.purchaseDate
        ? formatPrettyDate(headerPurchase.purchaseDate)
        : null;

    const expiresPretty =
      headerPurchase && headerPurchase.expirationDate
        ? formatPrettyDate(headerPurchase.expirationDate)
        : null;

    const hasLifetimeAccess =
      headerPurchase && headerPurchase.hasLifetimeAccess;

    const hasUnlimitedTutor =
      headerPurchase && headerPurchase.hasUnlimitedTutor;

    // The header described every owned plan as "Purchased … Expires: X".
    // Neither word is right for a subscription: it is subscribed, not
    // purchased, and the date is a RENEWAL while it is live and an
    // ACCESS-UNTIL once it is cancelled. Same vocabulary as the plan cards
    // and the course tiles — see common/subscriptionBadge.js.
    const primarySub = (primaryOwned && primaryOwned.subscription) || null;
    const headerBadge = getSubscriptionBadge(primarySub);
    const headerDateLabel = getSubscriptionDateLabel(primarySub);
    // The subscription's own expiry is authoritative when present; the
    // header's expirationDate is derived and can lag.
    const headerExpiry =
      primarySub && primarySub.expiryDate
        ? formatPrettyDate(primarySub.expiryDate)
        : expiresPretty;

    return (
      <div className="sp_container_header">
        <div className="sp_header_row">
          <button
            type="button"
            className="sp_back_btn"
            onClick={this.goBackToCourses}
            aria-label="Back"
            title="Back"
          >
            <span className="sp_back_icon" />
          </button>

          <div>
            <div className="sp_container_title">STUDY PACKAGE</div>
            <h1 className="sp_container_subtitle">{exam.uiTitle}</h1>
          </div>
        </div>

        {headerEntitlements && headerEntitlements.length > 0 ? (
          <div className="sp_purchased_block">
            {headerEntitlements.map((item, i) => this.renderEntitlement(item, i))}
          </div>
        ) : headerPurchase &&
          <div className="sp_purchased_block">
            <div className="sp_purchased_container">
              <div
                className={
                  'sp_purchased_header sb_card_meta_row' +
                  (primarySub ? ' sp_badge_tone_' + headerBadge.tone : '')
                }
              >
                <span className="sb_card_meta_icon sp_icon_purchased" />
                <span>{headerBadge.label}</span>
              </div>

              <div className="sp_purchased_title">{(() => {
                let title = primaryOwned ? (primaryOwned.package_type || "Purchased") : "Purchased";
                const eid = Number(exam && exam.id);
                if (eid === 13 || eid === 14) {
                  const ownedNonMock = (packages || []).filter(
                    p => p && p.isOwned && p.package_category !== 'mock'
                  );
                  if (ownedNonMock.length > 1) {
                    title = ownedNonMock.map(p => p.package_type).filter(Boolean).join(' + ');
                  }
                }
                return title;
              })()}</div>

              {purchasedPretty && (
                <div className="sb_card_meta_row sb_card_meta_row_grey">
                  <span className="sb_card_meta_icon sb_card_meta_icon_calendar" />
                  <span>{(primarySub ? 'Subscribed: ' : 'Purchased: ') + purchasedPretty}</span>
                </div>
              )}

              {headerExpiry && (
                <div className="sb_card_meta_row sb_card_meta_row_grey">
                  <span className="sb_card_meta_icon sb_card_meta_icon_clock" />
                  <span>{headerDateLabel + headerExpiry}</span>
                </div>
              )}

              {(hasLifetimeAccess || hasUnlimitedTutor) && (
                <div className="sb_card_meta_row sb_card_meta_row_green">
                  {hasLifetimeAccess && (
                    <div className="sb_card_meta_row">
                      <span className="sb_card_meta_icon sb_card_meta_icon_infinity" />
                      <span>Lifetime</span>
                    </div>
                  )}

                  {hasUnlimitedTutor && (
                    <div className="sb_card_meta_row">
                      <span className="sb_card_meta_icon sb_card_meta_icon_chat" />
                      <span>Unlimited Tutor</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        }
      </div>
    );
  }

  renderPackageDesc(plan) {
    const html = plan && plan.package_desc ? String(plan.package_desc) : "";
    return <div className="sp_plan_features" dangerouslySetInnerHTML={{ __html: html }} />;
  }

  renderAddons(plan) {
    if (!plan || !!(plan && plan.package_val === "unlimited")) return null;
    // Monthly packages carry no add-ons (requirement 2026-08-25). A subscription
    // bills current_price_id only, so an add-on priced here would never be charged.
    if (this.isRecurringPlan(plan)) return null;

    const {
      addons = [],
      planId
    } = plan;

    if (!addons.length) return null;

    const selectedMap = this.state.selectedAddonsByPlanId || {};
    const planMap = selectedMap[planId] || {};

    return (
      <div className="sp_plan_addons_block">
        <div className="sp_plan_addons_title">Optional Add-ons</div>

        <div className="sp_plan_addons_box">
          {addons.map((addon) => {
            if (!addon) return null;

            const aid = addon.id;
            const isOwned = !!addon.owned;
            const isInherited = !!addon.inherited;
            const isLocked = isOwned || isInherited;

            const checked = !isLocked && !!planMap[aid];

            return (
              <div
                key={aid}
                className={
                  "sb_enhance_panel_item" +
                  ((checked || isLocked) ? " sb_enhance_panel_item_active" : "") +
                  (isLocked ? " sb_enhance_panel_item_owned" : "")
                }
                onClick={() => {
                  if (isLocked) return;
                  this.onToggleAddon(planId, aid);
                }}
              >
                <input
                  type="checkbox"
                  aria-label={addon.title}
                  checked={isLocked ? true : checked}
                  disabled={isLocked}
                  onChange={() => {
                    if (isLocked) return;
                    this.onToggleAddon(planId, aid);
                  }}
                  onClick={(e) => e.stopPropagation()}
                />

                <div className="sb_panel_item_name">{addon.title}</div>

                {isLocked ? (
                  <span className={"sb_addon_status_badge" + (isLocked ? " sb_addon_badge_is_owned" : "")}>
                    {isOwned ? "Purchased" : "Included"}
                  </span>
                ) : (
                  <div className="sb_price_addon_block">
                    {addon.tooltip_description ? (
                      <span className="sb_addon_tooltip_wrap">
                        <span className="sb_addon_tooltip_icon">i</span>
                        <span className="sb_addon_tooltip_popup">
                          {String(addon.tooltip_description).replace(/<[^>]*>/g, "")}
                        </span>
                      </span>
                    ) : null}

                    <div className="sb_panel_item_price">
                      {"+ " + formatMoney(addon.price)}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  getIntervalLabel(payment_interval) {
    if (!payment_interval) return "";

    const labels = {
      day: "daily",
      week: "weekly",
      month: "monthly",
      year: "yearly",
    };

    return labels[payment_interval.toLowerCase()] || "";
  }

  renderPlanCard(plan) {
    if (!plan) return null;

    const { packages = [] } = this.state;

    const {
      isOwned = false,
      price = 0,
      originalPrice = null,
      planId = 0,
      package_type,
      payment_interval
    } = plan;

    const hasPartnerPrice = originalPrice !== null && originalPrice !== price;

    const isDisabled = this.isIncludedInPurchasedPackage(plan, packages);
    const proposeUpgrade = this.shouldShowUpgrade(plan);
    const isUpgradeUnlimited = proposeUpgrade && plan.upgradeType === 'upgrade_unlimited';
    const isUpgradePlus = proposeUpgrade && plan.upgradeType === 'upgrade_plus';
    const isPlus = plan.package_val === 'plus';
    const best = !proposeUpgrade && this.isBestValue(plan);

    const selectedAddonsTotal = this.getSelectedAddonsTotal(plan);
    const hasSelected = selectedAddonsTotal > 0;

    const upgradeCredit = proposeUpgrade ? (Number(plan.upgradeCredit) || 0) : 0;
    const upgradePrice = proposeUpgrade
      ? Math.max(0, price + selectedAddonsTotal - upgradeCredit)
      : 0;
    let displayPrice;
    if (proposeUpgrade) {
      displayPrice = upgradePrice;
    } else if (isOwned) {
      displayPrice = price;
    } else {
      displayPrice = price + selectedAddonsTotal;
    }

    const canBuy = !isDisabled && (proposeUpgrade || !isOwned || hasSelected);
    const isPurchasedCard = isOwned && !isDisabled;

    let cardClass = "sp_plan_card";
    if (isDisabled) cardClass += " sp_plan_card_lower";
    else if (isOwned) cardClass += " sp_plan_card_owned";
    else if (isUpgradePlus) cardClass += " sp_plan_card_best sp_plan_card_plus";
    else if (isUpgradeUnlimited) cardClass += " sp_plan_card_best";
    else if (proposeUpgrade) cardClass += " sp_plan_card_upgrade";
    else if (isPlus) cardClass += " sp_plan_card_best sp_plan_card_plus";
    else if (best) cardClass += " sp_plan_card_best";

    // A recurring plan whose subscription was cancelled or has lapsed is
    // purchasable again (see ownership rules in /getExamPackagesByUserId).
    // Without this the card silently reverts to a plain buy card and the user
    // has no idea their subscription ended, expired.
    // Subscription state drives the badge whether or not the plan is still
    // owned. A `cancelling` plan IS owned, so gating on !isOwned rendered a
    // blue "Purchased" here while /subscribe said "Cancelled" for the same plan.
    // An `expired` plan is no longer owned (it is buyable again) but still gets
    // a badge so the user can see why.
    const subState = plan.subscription || null;
    const subBadge = subState ? getSubscriptionBadge(subState) : null;
    const showSubBadge = !!subBadge && (isPurchasedCard || subState.status === 'expired');

    let badge = null;
    if (!isDisabled) {
      if (showSubBadge) {
        badge = (
          <div className={"sp_plan_badge sb_card_meta_row sp_badge_tone_" + subBadge.tone}>
            <span>{subBadge.label}</span>
          </div>
        );
      }
      else if (isPurchasedCard) {
        badge = (
          <div className="sp_plan_badge sb_card_meta_row sp_badge_purchased">
            <span className="sb_card_meta_icon sp_icon_badge_purchased" />
            <span>Purchased</span>
          </div>
        );
      }
      else if (isUpgradePlus) {
        badge = (
          <div className="sp_plan_badge sb_card_meta_row sp_badge_launch_special">
            <span className="sb_card_meta_icon sp_icon_badge_upgrade" />
            <span>Upgrade</span>
          </div>
        );
      }
      else if (isUpgradeUnlimited) {
        badge = (
          <div className="sp_plan_badge sb_card_meta_row sp_badge_best">
            <span className="sb_card_meta_icon sp_icon_badge_upgrade" />
            <span>Upgrade</span>
          </div>
        );
      }
      else if (proposeUpgrade) {
        badge = (
          <div className="sp_plan_badge sb_card_meta_row sp_badge_upgrade">
            <span className="sb_card_meta_icon sp_icon_badge_upgrade" />
            <span>Upgrade</span>
          </div>
        );
      }
      else if (isPlus) {
        badge = <div className="sp_plan_badge sp_badge_launch_special">Launch Special</div>;
      }
      else if (best) {
        badge = <div className="sp_plan_badge sp_badge_best">Best Value</div>;
      }
    }

    const combinedPrice =
      hasSelected
        ? (formatMoney(price) + " + " + formatMoney(selectedAddonsTotal) + " add-ons")
        : null;

    let buttonInner = null;

    if (isDisabled) {
      buttonInner = <div className="sb_card_meta_row">Included in Purchased Package</div>;
    } else if (isPurchasedCard && !hasSelected) {
      // } else if (isOwned && isPrimaryOwned && !hasSelected || isOwned && isMock && !hasSelected) {
      buttonInner = (
        <div className="sb_card_meta_row">
          <span className="sp_icon_button_purchased" />
          Purchased
        </div>
      );
    }
    else if (proposeUpgrade) {
      buttonInner = (
        <div className="sb_card_meta_row">
          <span className="sp_btn_primary_icon" />
          Upgrade for {formatMoney(upgradePrice)}
        </div>
      );
    }
    else if (isOwned && hasSelected) {
      buttonInner = (
        <div className="sb_card_meta_row">
          <span className="sp_btn_primary_icon" />
          Add Extras to Cart (${selectedAddonsTotal})
        </div>
      );
    } else {
      buttonInner = (
        <div className="sb_card_meta_row">
          <span className="sp_btn_primary_icon" />
          Add To Cart
        </div>
      );
    }

    return (
      <div key={planId} className={cardClass}>
        {badge}

        <div className="sp_plan_card_body">
          <div className="sp_plan_descript">{package_type}</div>

          <div className="sp_plan_price">
            {hasPartnerPrice && (
              <span className="sp_plan_price_original">{formatMoney(originalPrice)}</span>
            )}

            {proposeUpgrade && !hasPartnerPrice && upgradeCredit > 0 && (
              <span className="sp_plan_price_original">{formatMoney(price)}</span>
            )}
            {formatMoney(displayPrice)}
            {payment_interval ? <span className="sp_plan_price_interval"> /  {payment_interval}</span> : null}
          </div>
          {hasPartnerPrice ? <span className="sp_plan_price_billed">Partner price</span> : ""}
          {payment_interval ? <span className="sp_plan_price_billed">Billed {this.getIntervalLabel(payment_interval)} · cancel anytime</span> : null}

          <div className="sp_combined_price">
            {proposeUpgrade && hasSelected
              ? (formatMoney(price) + " + " + formatMoney(selectedAddonsTotal) + " add-ons − " + formatMoney(upgradeCredit) + " credit")
              : (!isOwned && combinedPrice)
            }
          </div>


          {this.renderPackageDesc(plan)}

          <div className="sp_plan_add_card">
            {isDisabled ? null : this.renderAddons(plan)}

            <button
              disabled={!canBuy}
              className={"sp_btn_primary " + (hasSelected ? "sp_addons_has_selected" : isPlus ? "sp_badge_launch_special" : "")}
              onClick={() => {
                if (!canBuy) return;
                this.handleAddToCart(plan, isOwned, proposeUpgrade, displayPrice);
              }}
            >
              {buttonInner}
            </button>
          </div>
        </div>
      </div>
    );
  }

  isCfaLevelOnePage() {
    const { exam } = this.state;
    return !!(exam && Number(exam.id) === 1);
  }

  renderBillingSwitch() {
    const { packages, billingTerm } = this.state;
    if (!this.hasBillingChoice(packages)) return null;

    return (
      <div className="sp_billing_switch_wrap">
        <div className="sp_billing_switch" role="group" aria-label="Billing period">
          <button
            type="button"
            className={"sp_billing_switch_option" + (billingTerm === "year" ? " is_active" : "")}
            aria-pressed={billingTerm === "year"}
            onClick={() => this.setBillingTerm("year")}
          >
            {/* Pay Yearly */}
            Annual Payment
          </button>
          <button
            type="button"
            className={"sp_billing_switch_option" + (billingTerm === "monthly" ? " is_active" : "")}
            aria-pressed={billingTerm === "monthly"}
            onClick={() => this.setBillingTerm("monthly")}
          >
            {/* Pay monthly */}
            Subscription
          </button>
        </div>
        {billingTerm === "monthly" ? (
          <div className="sp_billing_switch_note">
            {/* Monthly applies to per-level study packages only. */}
            Subscriptions apply to per-level study packages only.
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const { isLoading, errorMessage, packages, billingTerm } = this.state;

    if (isLoading) {
      return (
        <div className='animated fadeIn'>
          <Loader />
        </div>
      );
    }

    // Keep the wider CFA Level I page layout on every CFA L1 visit regardless of
    // the Plus-visibility feature flag. The grid itself adjusts column count by
    // card count (see `.sp_plans_grid_cfa1` media rules), so 3 cards no longer
    // leave dead right-column space and aren't centered in an oversized gutter.
    const isCfa1 = this.isCfaLevelOnePage();
    const isCfa1WithPlus = isCfa1 && SHOW_CFA_UNLIMITED_PLUS;

    return (
      <div className='animated fadeIn'>
        {errorMessage ? (
          <div className="sb_error_message">{errorMessage}</div>
        ) :
          <div className={"sb_page_container " + (isCfa1 ? "special_cfa1_width" : "")}>
            {this.renderHeader()}
            {this.renderBillingSwitch()}
            <div className={"sp_plans_grid " + (isCfa1WithPlus ? "sp_plans_grid_cfa1" : "")}>
              {this.filterPackagesByTerm(packages, billingTerm).map((p) => this.renderPlanCard(p))}
            </div>
          </div>
        }
      </div>
    );
  }
}

/* class SelectPackage extends Component { // old flow
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: language.LC().ALERT,
      MessageContent: language.LC().ERROR,
      exams: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      answered: [],
      plan_data: '',
      pack_class: 'hide_block',
      exam_name: '',
      exam_class: 'row',
      extras_1: false,
      extras_2: false,
      checkedStatus: false,
      disable: false,
      isLoading: true,
      China_price: 6.55,
      canadian_price: 5.22,
      usd_canadian_price: 1.26,
      userRole: '',
      partnerId: null,
      package_data: null,
    };

    this.toggleAlert = this.toggleAlert.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggleAlert() {
    this.setState((prevState) => ({ alert_status: !prevState.alert_status }));
  }

  getExams = () => {
    this.context.router.push({ pathname: '/subscribe' });
  };

  async getPackages() {
    const { token, idname, userRole, partnerId } = this.state;
    const exam_id = parseInt(this.props.params.exam_id);
    const data = { token, idname, exam_id };

    try {
      const packagesData = await FD.callAPI(
        `${App_data.backend_api}/checkout_v1/getPackages`,
        data,
      );

      if (!packagesData.success) {
        this.setState({
          ValidToken: false,
          package_data: <div>{language.LC().NO_PACKAGE_FOUND}</div>,
        });
        return;
      }

      const examPlansDetails =
        userRole === ROLES.PARTNER && partnerId
          ? await retrieveSpecialPrice(partnerId, packagesData.exam_plans)
          : packagesData.exam_plans;

      const packageDetails = examPlansDetails.length ? (
        examPlansDetails.map((item, index) => {
          if (item.role === ROLES.EMPLOYEE && userRole !== ROLES.EMPLOYEE) return null;

          const planExtras =
            item.extras &&
            item.extras.map((extra, index) => (
              <label className='check_container' key={index} id={`extras_${item.id}_${extra.id}`}>
                <CheckboxComponent
                  checkedStatus={this.state.checkedStatus}
                  id={`${item.id}_${extra.id}`}
                  extrasPrice={extra.price}
                  index={item.id}
                />
                <span className='checkmark' />
                {renderHTMLContent(extra.tooltip_description, 'span', 'extras_desc')}
                <span className='white_space_extras_price'>{`- $${extra.price}`}</span>
              </label>
            ));

          const planDescription = renderHTMLContent(item.package_desc, 'div', 'plan_desc');
          const { exam_name } = this.props.params;
          const hideExtras =
            item.package_category === 'mock' || exam_name === 'gmat_focus' || exam_name === 'ea';
          const isUnlimited = item.package_val === 'unlimited';

          return (
            <div className='col-lg-4' key={index}>
              <div className='plan_wrapper' id={`plan_wrapper_${item.id}`}>
                <div className='plan_header'>
                  {item.package_type}
                  <img
                    src={`${App_data.frontend_url}/img/subscription/greenTick.svg`}
                    alt=''
                    width='20'
                    id={`purchasedBadge${item.id}`}
                  />
                </div>
                <div className={`plan_price ${item.payment_interval ? 'font-4xl' : ''}`}>
                  $
                  <span id={`price_${item.id}`}>
                    {item.payment_interval ? `${item.price}/${item.payment_interval}` : item.price}
                  </span>
                </div>
                <div className='plan_text'>
                  {planDescription}
                  {!isUnlimited && !hideExtras && (
                    <div className='plan_extras' style={{ position: 'relative' }}>
                      <h4 className='extras_header'>{language.LC().EXTRAS}</h4>
                      <div className='extras-cover'>{planExtras}</div>
                    </div>
                  )}
                </div>
                <BuyPackages
                  idname={idname}
                  token={token}
                  itemval={item}
                  exam_name={this.state.exam_name}
                  {...this.props}
                />
              </div>
            </div>
          );
        })
      ) : (
        <div>{language.LC().NO_PACKAGE_FOUND}</div>
      );

      this.setState({
        ValidToken: true,
        pack_class: 'row',
        exam_name: this.props.params.exam_name,
        exam_class: 'hide_block',
        resp: packagesData,
        isLoading: false,
        package_data: packageDetails,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    const session = JSON.parse(localStorage.getItem('localstorageval')) || {};
    const { idname, token } = session;
    const data = { idname, token };

    // FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data).then((resp) => {
    userStore.getUserProfile().then((resp) => {
      this.setState(
        {
          userRole: resp.role,
          partnerId: resp.partnerID || null,
          idname,
          token,
        },
        this.getPackages,
      );
    });
  }

  render() {
    const {
      isLoading,
      pack_class: packageClass,
      package_data,
      alert_status,
      MessageTitle,
      MessageContent,
      exam_name,
    } = this.state;

    return (
      <div className='animated fadeIn'>
        {isLoading ? (
          <Loader />
        ) : packageClass === 'row' ? (
          <div className={packageClass}>
            <div className='col-lg-12 text-center subscription-card-cover subscription-plan-wrap'>
              <div className='subscription-card'>
                <Button
                  type='button'
                  className='btn btn-primary pointer_class mob_back padding-0'
                  onClick={this.getExams}
                >
                  <i className='fa fa-arrow-left' aria-hidden='true' />
                </Button>
                <div className='subscription-heading-wrap'>
                  <div className='subscription-img'>
                    <img
                      src={`${App_data.frontend_url}/img/subscription/subscription_icon2.svg`}
                      alt='subscription icon'
                      width='30'
                    />
                  </div>
                  <h4>{EXAM_MAPPING[exam_name] || exam_name}</h4>
                </div>
              </div>
            </div>

            <div className='col-lg-12 text-center align-self-center'>
              <div
                className={`row subscription_wrap row-gap-3 ${package_data && package_data.length > 1 ? '' : 'package-alignment'}`}
              >
                {package_data}
              </div>
            </div>

            <Modal
              isOpen={alert_status}
              toggle={this.toggleAlert}
              className={`modal-danger ${this.props.className}`}
            >
              <ModalHeader toggle={this.toggleAlert}>{MessageTitle}</ModalHeader>
              <ModalBody>
                <strong>{MessageContent}</strong>
              </ModalBody>
              <ModalFooter>
                <Button color='secondary' onClick={this.toggleAlert}>
                  {language.LC().OK}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        ) : null}
      </div>
    );
  }
} */

export default SelectPackage;



// WEBPACK FOOTER //
// ./src/views/Subscribe/SelectPackages/SelectPackage.js